<template>
  <d-container fluid>
    <d-row>
      <!-- Main Sidebar -->
      <main-sidebar :items="sidebarItems" :hide-logo-text="true" />

      <d-col class="main-content offset-lg-2 offset-md-3 p-0" tag="main" lg="10" md="9" sm="12">

        <!-- Main Navbar -->
        <main-navbar />

        <!-- Content -->
        <slot />
        <router-view/>

        <!-- Main Footer -->
        <main-footer />
      </d-col>

    </d-row>
  </d-container>
</template>

<script>
import getSidebarItems from '../navs/sidebar-nav-items'

// Main layout components
import MainNavbar from '../components/layout/MainNavbar/MainNavbar.vue'
import MainSidebar from '../components/layout/MainSidebar/MainSidebar.vue'
import MainFooter from '../components/layout/MainFooter/MainFooter.vue'
import {Api} from "../helpers"
import {Auth} from "../mixins/AuthMixin"

export default {
  name: 'analytics',
  components: {
    MainNavbar,
    MainSidebar,
    MainFooter,
  },
  data() {
    return {
      issuesCount: 0,
      fetchingIssuesCount: false
    }
  },
  computed: {
    sidebarItems() {
      return getSidebarItems({issuesCount: this.issuesCount})
    }
  },
  beforeCreate() {
    if(this.$route.name === 'index')
      this.$router.push(Auth.homePage())
  },
  created() {
    this.refreshIssuesCount()
  },
  beforeUpdate() {
    this.refreshIssuesCount()
  },
  methods: {
    refreshIssuesCount() {
      this.fetchingIssuesCount = true
      Api.get('/issue/unresolved')
        .then(res => this.issuesCount = res.data)
        .catch(err => console.log(err))
        .then(() => this.fetchingIssuesCount = false)
    }
  }
};
</script>
